import { isPresent } from 'lib/utils'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IAlert, selectCities } from 'store/api'
import { selectCity } from 'store/auth'
import useSlug from './useSlug'

const useAlerts = (pageType: string) => {
  const { queryLng } = useSlug()

  const city = useSelector(selectCity)
  const cities = useSelector(selectCities(queryLng))

  const alerts: IAlert[] = useMemo(() => {
    const cityInfo = cities.find((c) => c.code === city)
    return isPresent(cityInfo) ? cityInfo.alerts : []
  }, [cities, city])

  // Записи с типом 'ticker' — это бегущая строка в шапке (компонент Ticker),
  // плашками их показывать нельзя ни при каких pages. Раньше от этого спасала
  // только служебная метка pages=['_ticker'], но её затирает любое сохранение
  // записи через админку — фраза уехала бы на главную плашкой (06.08).
  const visible = alerts.filter((a) => (a as any).type !== 'ticker')

  if (pageType === 'home')
    return visible.filter((a) => a.pages === null)
  else return visible.filter((a) => a.pages?.includes(pageType))
}

export default useAlerts
